class CountryValidation {
	setDomElements(e) {
		this.countrySelection = e.target.closest('.country-selection');
		this.billingForm = document.getElementById('billingForm');

		this.countrySelect = this.countrySelection?.querySelector(
			'.country-selection__select',
		);
	}

	listeners() {
		if (document.querySelector('.js-input-validation-wrapper')) {
			document.addEventListener('change', e => {
				this.setDomElements(e);

				if (e.target !== this.countrySelect || !this.billingForm) {
					return;
				}

				const selectCountryUrl =
					this.countrySelection?.dataset.selectCountryUrl;
				if (!selectCountryUrl) {
					return;
				}

				this.billingForm.action = selectCountryUrl;
				this.billingForm.submit();
			});
		}
	}

	init() {
		const countrySelect = document.querySelector('.country-selection__select');
		if (countrySelect && window.od?.OdSelect) {
			new window.od.OdSelect(countrySelect);
		}
		this.listeners();
	}
}

export default CountryValidation;
